import commodity from './commodity.vue'
export default commodity